import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Typography,
} from "fds";
import "./index.scss";
import MeetingForm from "./MeetingForm";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import MeetingBottom from "../../../components/MeetingBottom";
import { meetingDTO, ZoomRequestDto } from "../../../types/meeting";
import useMeetingStore from "../../../redux/dispatcher/useMeetingStore";
import useAppStore from "../../../redux/dispatcher/useAppStore";
import AppRegisterModal from "../../../components/AppRegisterModal";
import { t } from "i18next";
import { Trans } from "react-i18next";
import currentUrlUtils from "../../../shared/utils/currentUrlUtils";
const WorkgroupMeeting = ({ workgroupId }: { workgroupId: string }) => {
  const { subTab } = currentUrlUtils.getAllFirstQuery();

  dayjs.extend(utc);
  const { appState, getAppLoginInfo } = useAppStore();
  const { meetingState, getmeetingList } = useMeetingStore();
  const [meetingList, changeMeetingList] = useState<meetingDTO[]>([]);
  const [pageType, changePageType] = useState(
    subTab && !!appState.appRegisterStatus.zoom ? subTab : "LIST"
  );
  const [updateId, changeUpdateId] = useState("");
  const [buttonClick, setButtonClick] = useState(0);
  const [openConnectList, toggleOpenConnectList] = useState(false);
  const [filter, changeFilter] = useState<ZoomRequestDto>({
    startTime: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
    timeDirection: "future",
    resultSize: 20,
    pageNo: 1,
  });
  useEffect(() => {
    getAppLoginInfo("zoom").then((resp) => {
      if (resp.payload) {
        if (subTab && !appState.appRegisterStatus.zoom) {
          changePageType("CREATE");
        }
      } else {
        if (subTab && !appState.appRegisterStatus.zoom) {
          changePageType("LIST");
          toggleOpenConnectList(true);
          return;
        }
      }
    });
  }, []);
  useEffect(() => {
    getmeetingList({ workgroupId: workgroupId, zoomDto: filter });
  }, [filter]);
  useEffect(() => {
    changeMeetingList(meetingState.meetingList);
  }, [meetingState.meetingList]);
  useEffect(() => {
    const meetingId = sessionStorage.getItem("changeMeeting");
    if (!!meetingId) {
      changeUpdateId(meetingId);
      sessionStorage.removeItem("changeMeeting");
    }
  }, [subTab]);
  const renderFilter = () => {
    return (
      <Box alignItems="center" classes="mg mt-16">
        <Button
          leadingIcon={<Icons variant="line" label="redoLeft" />}
          btnStyle="icon"
          size={"sm"}
          state={filter.timeDirection === "future" ? "disable" : "default"}
          classes="mg mr-12"
          onClick={() => {
            changeFilter({
              ...filter,
              timeDirection: "future",
            });
          }}
        />
        <Dropdown
          placeholder={t("meeting.status")}
          btnStyle="round"
          showValue
          btnSize="rd"
          // defaultValue={t("meeting.planning")}
          buttonClick={buttonClick}
          buttonWidth={224}
          value={
            filter.timeDirection === "future"
              ? t("meeting.planning")
              : t("meeting.finish")
          }
          defaultValue={"future"}
          selectValue={filter.timeDirection}
        >
          <DropdownItem
            label={t("meeting.planning")}
            checkColor={filter.timeDirection === "future"}
            checked={filter.timeDirection === "future"}
            type="check"
            onClick={() => {
              changeFilter({
                ...filter,
                timeDirection: "future",
              });
              document.getElementById("docTable")?.scrollTo(0, 0);
              setButtonClick(buttonClick + 1);
            }}
          />
          <DropdownItem
            label={t("meeting.finish")}
            checkColor={filter.timeDirection !== "future"}
            checked={filter.timeDirection !== "future"}
            type="check"
            onClick={() => {
              changeFilter({
                startTime: dayjs().utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                resultSize: 20,
                pageNo: 1,
                timeDirection: "past",
              });
              document.getElementById("docTable")?.scrollTo(0, 0);
              setButtonClick(buttonClick + 1);
            }}
          />
        </Dropdown>
      </Box>
    );
  };
  const changeFilterByKey = (key: string, value: any) => {
    if (meetingState.meetingListInfo?.total > meetingList.length)
      changeFilter({ ...filter, [key]: value });
  };
  return (
    <Box
      width={"100%"}
      height={"calc(100% - 146px)"}
      classes={"workgroupMeeting"}
    >
      {openConnectList && (
        <AppRegisterModal
          open
          onClose={() => toggleOpenConnectList(false)}
          openLinkAppModal="open_zoom"
          modalType={"CONNECT"}
          handleAfter={() => {
            toggleOpenConnectList(false);
            changePageType("CREATE");
          }}
        />
      )}
      {pageType === "LIST" ? (
        <Box direction="column" width={"100%"}>
          {renderFilter()}
          <Box
            height={56}
            minHeight={56}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box alignItems="center" classes="mg mt-12">
              <Typography type="subtitle2">
                <Trans
                  i18nKey="meeting.withCount"
                  values={{ count: meetingState?.meetingListInfo?.total ?? 0 }}
                  components={{
                    1: (
                      <Typography
                        type="subtitle2"
                        classes="mg ml-4"
                        exactColor={getColor("COLOR_TEXT_BRAND")}
                      />
                    ),
                  }}
                />
              </Typography>
            </Box>
            <Button
              btnStyle="link"
              leadingIcon={<Icons variant="line" label="zoomIn" />}
              label={t("meeting.schedule")}
              onClick={() =>
                !!appState.appRegisterStatus.zoom
                  ? changePageType("CREATE")
                  : toggleOpenConnectList(true)
              }
            />
          </Box>
          <MeetingBottom
            meetingList={meetingList}
            handleCreateMeeting={() =>
              !!appState.appRegisterStatus.zoom
                ? changePageType("CREATE")
                : toggleOpenConnectList(true)
            }
            isInitFilter={filter.timeDirection === "future"}
            height="calc(100% - 120px)"
            tableHeight="calc(100vh - 380px)"
            changeEditMode={(id) => {
              changeUpdateId(id);
              changePageType("UPDATE");
            }}
            filter={filter}
            changeFilterByKey={changeFilterByKey}
            page="workgroup"
          />
        </Box>
      ) : (
        <MeetingForm
          zoomMeetingId={updateId}
          workgroupId={workgroupId}
          onBack={() => {
            changePageType("LIST");
            changeUpdateId("");
            subTab &&
              !window.location.href.includes("from=UidLink") &&
              window.history.back();
          }}
          handleAfterSubmit={() =>
            getmeetingList({ workgroupId: workgroupId, zoomDto: filter })
          }
        />
      )}
    </Box>
  );
};

export default WorkgroupMeeting;
